import { MessageStore, fromRecord } from 'sdi/locale';

const messages = {
    __empty__: {
        fr: '',
    },

    biggerMap: {
        fr: 'Agrandir la carte',
    },

    issues: {
        fr: 'Signalements',
    },

    allIssues: {
        fr: 'Tous',
    },

    newOrStalled: {
        fr: 'Nouveaux & En attente',
    },

    showMapAndTable: {
        fr: 'Afficher la carte et le tableau ',
    },

    cancelRemoveTag: {
        fr: 'Annuler la suppression',
    },

    addTag: {
        fr: 'Ajouter un tag',
    },

    addTagChangeSetMsg: {
        fr: 'Veuillez entrer un message de changeset (2 mots minimum).',
    },
    addTagSource: {
        fr: 'Veuillez entrer une ou plusieurs sources ("survey", "local knowledge", ...).',
    },
    addStationSource: {
        fr: 'Ajouter une source',
    },

    seeTable: {
        fr: 'Agrandir le tableau',
    },
    reduceTable: {
        fr: 'Réduire le tableau',
    },
    seeMap: {
        fr: 'Voir la carte',
    },
    seeMapAndTable: {
        fr: 'Tableau et carte',
    },
    hideTable: {
        fr: 'Cacher le tableau',
    },
    legend: {
        fr: 'Légende',
    },
    selection: {
        fr: 'Sélection',
    },
    criticality: {
        fr: 'Criticité',
    },
    geometry: {
        fr: 'Géométrie',
    },
    zoomToGeom: {
        fr: `zoomer sur l'objet`,
    },
    autoZoom: {
        fr: 'Zoom auto',
    },
    autoCenter: {
        fr: 'Centrage auto',
    },
    high: {
        fr: 'Haute',
    },
    medium: {
        fr: 'Moyenne',
    },
    low: {
        fr: 'Basse',
    },
    status: {
        fr: 'Statut',
    },
    followed: {
        fr: 'Suivi',
    },
    new: {
        fr: 'Nouveaux',
    },
    pending: {
        fr: 'En attente',
    },
    stalled: {
        fr: 'En attente',
    },
    validated: {
        fr: 'Validé',
    },
    corrected: {
        fr: 'Corrigé',
    },
    origin: {
        fr: 'Typologie',
    },
    version: {
        fr: 'Version',
    },
    qualityControl: {
        fr: 'Contrôle qualité',
    },
    changesMonitoring: {
        fr: 'Suivi des modifications',
    },
    internalBasisComparison: {
        fr: 'Comparaison base interne',
    },
    routingRegression: {
        fr: 'Régression Routing',
    },
    description: {
        fr: 'Description',
    },
    source: {
        fr: 'Sources',
    },
    priority: {
        fr: 'Priorité',
    },
    object: {
        fr: "Type d'objet",
    },
    OSMObject: {
        fr: 'Objet OSM',
    },
    contributor: {
        fr: 'Contributeur',
    },
    date: {
        fr: 'Date',
    },
    line: {
        fr: 'Lignes',
    },
    sector: {
        fr: 'Secteur',
    },
    tags: {
        fr: 'Tags et géométrie',
    },
    hashtags: {
        fr: 'Hashtags',
    },
    gallery: {
        fr: 'Galerie',
    },
    notes: {
        fr: 'Notes',
    },
    links: {
        fr: 'Liens',
    },
    exportTableCsv: {
        fr: 'Exporter en csv',
    },
    RAISED: {
        fr: 'Nouveau',
    },
    FALSE_POSITIVE: {
        fr: 'Faux-positif',
    },
    STALLED: {
        fr: 'En attente',
    },
    CORRECTED: {
        fr: 'Traité',
    },
    QA: {
        fr: 'Contrôle qualité',
    },
    CHANGE_DETECTION: {
        fr: 'Suivi des modifications',
    },
    CHANGE_DETECTION_CREATION: {
        fr: 'Elément créé',
    },
    CHANGE_DETECTION_MODIFICATION: {
        fr: 'Elément modifié',
    },
    CHANGE_DETECTION_DELETE: {
        fr: 'Elément supprimé',
    },
    CREATION_OR_MODIFICATION: {
        fr: 'Elément créé ou modifié',
    },
    COMPARISON: {
        fr: 'Comparaison base interne',
    },
    ROUTING: {
        fr: 'Routage',
    },
    EXTERNAL: {
        fr: 'Externe',
    },
    null: {
        fr: 'pas de valeur',
    },
    logout: {
        fr: 'Se déconnecter',
    },
    login: {
        fr: 'Se connecter',
    },
    issue: {
        fr: 'Signalement',
    },
    linkedIssues: {
        fr: 'Signalements liés',
    },
    seeInTable: {
        fr: 'Afficher dans le tableau',
    },
    cancelFilter: {
        fr: 'Annuler le filtre',
    },
    viewLinkedIssuesTable: {
        fr: 'Afficher les issues liées dans le tableau',
    },
    addLinkedIssue: {
        fr: 'Ajouter un signalement',
    },
    untieLinkedIssue: {
        fr: 'Retirer ce signalement',
    },
    cancelAddLinkedIssue: {
        fr: `Annuler l'ajout`,
    },
    addLinkedGroup: {
        fr: 'Créer un groupe',
    },
    addLinkedIssueHelptext: {
        fr: 'Veuillez sélectionner le signalement à ajouter',
    },
    deleteLinkedIssue: {
        fr: 'Délier le signalement courant de ce groupe',
    },
    name: {
        fr: 'Nom',
    },
    uic: {
        fr: 'Code UIC',
    },
    changeBackgroundMap: {
        fr: 'Fond de plan',
    },
    editGeom: {
        fr: 'Éditer la géométrie',
    },
    editTags: {
        fr: 'Éditer les tags',
    },
    unknown: {
        fr: 'Inconnu',
    },
    keyNumbers: {
        fr: 'Chiffres clés',
    },
    week: {
        fr: 'Semaine',
    },
    month: {
        fr: 'Mois',
    },
    year: {
        fr: 'Année',
    },
    newIssues: {
        fr: 'Nouveaux signalements',
    },
    linkedObject: {
        fr: 'liés par la référence OSM',
    },
    linkedLocation: {
        fr: 'liés par la localisation',
    },
    linkedChangeset: {
        fr: 'liés par le changeset',
    },
    linkedManual: {
        fr: 'liés manuellement',
    },
    OSM_OBJECT: {
        fr: 'liés par la référence OSM',
    },
    LOCATION: {
        fr: 'liés par la localisation',
    },
    CHANGESET: {
        fr: 'liés par le *changeset*',
    },
    MANUAL: {
        fr: 'liés manuellement',
    },
    evaluation: {
        fr: '',
    },
    WARNING: {
        fr: 'À surveiller',
    },
    CONFIDENT: {
        fr: 'De confiance',
    },
    NONE: {
        fr: 'Non évalué',
    },
    changesetComment: {
        fr: 'Message de changeset',
    },
    changesetSource: {
        fr: 'Source',
    },
    contact: {
        fr: 'Contacts',
    },
    selectIndoorLevel: {
        fr: 'Niveau',
    },
    seeLinkedIssues: {
        fr: 'Afficher dans le tableau',
    },
    backToFullTable: {
        fr: 'Retour au tableau complet',
    },
    selectLinkInTable: {
        fr: 'Selectionner le signalement à ajouter dans le tableau',
    },
    selectPriority: {
        fr: 'Criticité',
    },

    selectTypology: {
        fr: 'Typologie',
    },

    selectObjects: {
        fr: 'Objets',
    },

    steps: {
        fr: 'Escaliers et escalators',
    },
    'foot-routing': {
        fr: 'Autres cheminements piétons',
    },
    lift: {
        fr: 'Ascenseurs',
    },
    exit: {
        fr: 'Entrées et sorties',
    },
    emergency: {
        fr: "Équipement d'urgence",
    },
    restaurant: {
        fr: 'Restaurants',
    },
    toilet: {
        fr: 'Toilettes',
    },
    taxi: {
        fr: 'Taxis',
    },
    barrier: {
        fr: 'Obstacles',
    },
    structure: {
        fr: 'Structure',
    },
    service: {
        fr: 'Services',
    },
    intermodality: {
        fr: 'Intermodalité',
    },
    'street-furniture': {
        fr: 'Autre mobilier',
    },
    shop: {
        fr: 'Commerce',
    },
    phone: {
        fr: 'Téléphone',
    },
    parking: {
        fr: 'Parkings',
    },
    bicycle: {
        fr: 'Vélo',
    },
    energy: {
        fr: 'Énergie',
    },
    'vending-machine': {
        fr: 'DABs et automates de ventes',
    },
    'information-panel': {
        fr: "Panneaux d'information",
    },
    filteredByCriticality: {
        fr: 'Tableau filtré par criticité',
    },
    filteredByLinkGroup: {
        fr: 'Signalements liés par',
    },
    generalInfo: {
        fr: 'Informations générales',
    },
    detailedInfo: {
        fr: 'Détails du signalement',
    },
    additionalInfo: {
        fr: 'Informations complémentaires',
    },
    resolvingChangeset: {
        fr: 'Changeset de résolution',
    },
    addResolvingChangeset: {
        fr: 'Ajouter un changeset de résolution',
    },
    noOSMConnection: {
        fr: 'Non connecté à OSM',
    },
    viewOnMapillary: {
        fr: 'Voir sur Mapillary',
    },
    viewOnPanoramax: {
        fr: 'Voir sur Panoramax',
    },
    comment: {
        fr: 'Commentaire',
    },
    newName: {
        fr: 'Nouveau nom rapporté',
    },
    temporary_closed: {
        fr: 'Fermé temporairement',
    },
    definitely_closed: {
        fr: 'Fermé définitivement',
    },
    wheelchairaccessible: {
        fr: 'Inacesssible PMR',
    },
    is_not_present: {
        fr: 'Inexistant',
    },
    external_date: {
        fr: 'Date du signalement rapporté',
    },
    reported_info: {
        fr: 'Information rapportée',
    },
    no_themes: {
        fr: `Aucun thème n'a été défini. Rendez vous dans l'espace d'administration pour ajouter des thèmes.`,
    },
};

type MDB = typeof messages;
export type QaMessageKey = keyof MDB;

declare module 'sdi/locale' {
    export interface MessageStore {
        qa(k: QaMessageKey): Translated;
    }
}

MessageStore.prototype.qa = (k: QaMessageKey) => fromRecord(messages[k]);
